<template>
  <b-button 
    variant="primary" 
    disabled
    class="w-100" 
    @click="$emit('click')" 
    v-b-tooltip.hover 
    title="Disponível das 8h às 17h">
    Crédito
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'CreditButton',
  components: { BButton },
};
</script>
